import React from 'react';
import * as icons from './icons';

interface IconProps {
  className?: string;
  icon: string;
  filled?: boolean;
  size?: number;
  fill?: string;
}

export default function Icon({ icon, ...others }: IconProps) {
  //@ts-ignore
  const Element = icon in icons ? icons[icon] : () => null;
  return <Element {...others} />;
}